import { ListDeviceModels } from './__generated__/ListDeviceModels'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const DEVICE_MODELS_QUERY = gql`
  query ListDeviceModels {
    deviceModels {
      id
      title
    }
  }
`

export const useListDeviceModels = () => {
  return useQuery<ListDeviceModels>(DEVICE_MODELS_QUERY)
}
